import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav class="navbar navbar-expand navbar-light bg-light">
      <div class="container">
        <Link to="/" class="navbar-brand">
          Match Calculator
        </Link>

        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <Link to="/" class="nav-link active" aria-current="page">
              Home
            </Link>
          </li>
          <li class="nav-item">
            <Link to="/amount" class="nav-link">
              Link
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
